import { render, staticRenderFns } from "./cloud-recording.vue?vue&type=template&id=7accc95a&scoped=true"
import script from "./cloud-recording.vue?vue&type=script&lang=js"
export * from "./cloud-recording.vue?vue&type=script&lang=js"
import style0 from "./cloud-recording.vue?vue&type=style&index=0&id=7accc95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7accc95a",
  null
  
)

export default component.exports